import { Component } from 'react';
import { Tabs, Row, Col } from 'antd';
import BusConfig from "@/config/bus";
import Student from "@/config/student";
import RollCallonfig from "@/config/rollCall";
import {
  convertToTimestamp,
  startTimeToday,
  dayOfWeekArray,
  getDayVacationDateParams,
  getDayMakeUpDateParams,
  startThisMonth,
  endThisMonth,
} from "@/lib/dateTime";
import BusTime from './BusTime';
import './index.less'

const { getBusTimeInfo } = BusConfig;
const { getAllStudent } = Student;
const { getVacationAndMakeUpDay } = RollCallonfig;
const { TabPane } = Tabs;

interface state {
  busTimeArray: any;
  allStudentArray: any;
  specialDateArray: any;
  busTimeObject: any;
  activeDayKey: number;
}

class Bus extends Component<{}, state> {
  state = {
    busTimeArray: [] as never as any,
    allStudentArray: [],
    specialDateArray: [],
    busTimeObject: {} as never as any,
    activeDayKey: 0,
  };
  constActiveDayKey = 0;

  componentDidMount() {
    this.getAllStudent();
    Promise.all([this.getBusTimeInfo(), this.getVacationAndMakeUpDay()]).then((res: any) => {
      const specialDateArray = res?.[1] ?? [];
      const { isDayMakeUpDay, makeUpDayOfWeekIndex } = getDayMakeUpDateParams({ specialDateArray });
      const activeDayKey = isDayMakeUpDay ? makeUpDayOfWeekIndex + 1 : startTimeToday.weekday();

      this.constActiveDayKey = activeDayKey;
      this.setState({ activeDayKey });
    });
  }

  getAllStudent = () => {
    getAllStudent().then((res: any) => {
      const allStudentArray = res?.value ?? [];
      this.setState({ allStudentArray });
    });
  }

  getBusTimeInfo = async () => {
    return getBusTimeInfo().then((res: any) => {
      const data = res?.value ?? {};
      const tempBusTimeObject: any = {};

      dayOfWeekArray.forEach((key: any) => {
        tempBusTimeObject[key] = data?.[key] ?? [];
      });

      this.setState({ busTimeObject: tempBusTimeObject });
    });
  }

  getVacationAndMakeUpDay = async () => {
    const params = { startTime: convertToTimestamp(startThisMonth), endTime: convertToTimestamp(endThisMonth) };

    return getVacationAndMakeUpDay(params).then((res: any) => {
      const specialDateArray = res?.value ?? [];

      this.setState({ specialDateArray });
      return specialDateArray;
    });
  }

  getDayTitle = (day: string) => {
    const { specialDateArray } = this.state;
    const { makeUpDayOfWeekIndex } = getDayMakeUpDateParams({ specialDateArray });
    const { vacationDayOfWeekIndex } = getDayVacationDateParams({ specialDateArray });

    if (dayOfWeekArray[makeUpDayOfWeekIndex] === day) {
      return `${day} (補班)`;
    }
    if (dayOfWeekArray[vacationDayOfWeekIndex] === day) {
      return `${day} (補假)`;
    }
    return day;
  }

  renderBusTimeTab = () => {
    const { allStudentArray, busTimeObject, activeDayKey } = this.state;
    const dayOfWeek = dayOfWeekArray[activeDayKey - 1];
    const busTimeArray = busTimeObject?.[dayOfWeek] ?? [];

    return dayOfWeekArray.map((day: string, index: number) => (
      <TabPane key={index + 1} tab={this.getDayTitle(day)}>
        <BusTime
          allStudentArray={allStudentArray}
          busTimeArray={busTimeArray}
          getBusTimeInfo={this.getBusTimeInfo}
          activeDayKey={activeDayKey}
          constActiveDayKey={this.constActiveDayKey}
        />
      </TabPane>
    ));
  }

  render() {
    const { activeDayKey } = this.state;

    return (
      <>
        <Row className="bus-page">
          <Col span={24}>
            <Tabs
              size="large"
              destroyInactiveTabPane
              onChange={(activeKey: any) => this.setState({ activeDayKey: activeKey * 1 })}
              activeKey={`${activeDayKey}`}
              type="card"
            >
              {this.renderBusTimeTab()}
            </Tabs>
          </Col>
        </Row>
      </>
    );
  }
}

export default Bus;